import { createApp } from 'vue'
import { createPinia } from 'pinia'

// Ensure the tree styles are always available
import 'element-plus/es/components/base/style/css'
import 'element-plus/es/components/tree/style/css'
import 'element-plus/es/components/table/style/css'

import App from '../src/vendor/VendorApp.vue'
import router from '../src/vendor/router/index'
import vueConfig from '../src/lib/vueConfig'
import { setupAuthInterceptor } from '../src/shared/auth/clientInterceptor'
import { setupErrorHandling } from '../src/shared/errorHandling'

// Import the v3.1 vendor client
import { client } from '@/v31-vendor/client.gen'

// Configure the v3.1 client
client.setConfig({
  baseUrl: '/vendor/api/',
})

setupAuthInterceptor(client)

if (import.meta.env.PROD) {
  // init anything running in PROD here
}

const vendorApp = createApp(App)

setupErrorHandling(vendorApp)

const pinia = createPinia()
vendorApp.use(pinia)

vendorApp.use(router)
vueConfig.initElement(vendorApp)

async function initApp() {
  vendorApp.mount('#app')
}

initApp()
